module.exports = __webpack_public_path__ + "img/fontello.34a6468.svg";